import { marcarComoApresentado, jaFoiApresentado } from "./catalogo";

/**
 * Rede de segurança para promise de chamada HTTP que ninguém tratou.
 *
 * O `ApiService` rejeita a promise no erro; uma cadeia sem `.catch` em chamada
 * com `noToast` (ou feita por `ApiService.query`, que nunca mostrou nada) falha
 * em **silêncio absoluto**: o usuário clica, o loading some e nada aparece.
 * Isto é o último recurso -- a regra continua sendo tratar o erro onde ele
 * acontece, porque só ali se sabe qual campo destacar e o que reverter na tela.
 *
 * O que NÃO passa por aqui, de propósito:
 *
 * - rejeição que não é falha de chamada. A mais comum é o `NavigationDuplicated`
 *   do Vue Router: clicar duas vezes no mesmo item do menu rejeita a promise do
 *   `$router.push` e não é erro nenhum. Sem esse filtro, a rede viraria um
 *   gerador de avisos falsos.
 * - erro que alguém já apresentou (`valoremApresentado`), para não duplicar.
 * - requisição cancelada, que o `apresentarErro` já ignora.
 */

let instalada = false;

// Falha de chamada HTTP tem uma destas marcas: a interpretação que o interceptor
// do Axios anexa, a flag do próprio Axios, ou uma resposta do servidor.
const ehFalhaDeChamada = (err) =>
  !!err &&
  typeof err === "object" &&
  (!!err.valorem || err.isAxiosError === true || !!err.response);

export function instalarRedeDeErroGlobal(vm) {
  if (instalada || typeof window === "undefined") return;
  instalada = true;

  window.addEventListener("unhandledrejection", (evento) => {
    const err = evento && evento.reason;

    if (!ehFalhaDeChamada(err) || jaFoiApresentado(err)) return;

    try {
      // Não chamamos preventDefault: o "Uncaught (in promise)" continua no
      // console do navegador, e é ele que aponta a chamada sem `.catch`.
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn(
          "[erros] chamada HTTP sem .catch -- a rede global apresentou o erro. " +
            "Trate na origem com .catch((err) => this.tratarErro(err)).",
          err.config && err.config.url
        );
      }

      // Nesta ordem: o `tratarErro` só apresenta enquanto o erro não estiver
      // marcado, então marcar antes dele engoliria a mensagem.
      vm.tratarErro(err);
      marcarComoApresentado(err);
    } catch (e) {
      // A rede de segurança nunca pode ser a causa de um novo erro.
      // eslint-disable-next-line no-console
      console.error("[erros] falha na própria rede global", e);
    }
  });
}
